/**
 * Unit-details layout bands (web).
 * Matches listing tablet: phone < 768, tablet 768–1099, desktop ≥ 1100.
 * iPad (768) and iPad Pro 12.9 portrait (1024) stay compact (stacked + sticky footer).
 */
export const UNIT_DETAILS_PHONE_MAX = 768;
export const UNIT_DETAILS_TABLET_MAX = 1100;

export interface UnitDetailsLayout {
  readonly isPhone: boolean;
  readonly isTablet: boolean;
  /** Phone + tablet: stacked content and sticky footer (not desktop sidebar). */
  readonly isCompact: boolean;
  readonly carouselHeight: number;
}

function resolveCarouselHeight(isPhone: boolean, isTablet: boolean): number {
  if (isPhone) {
    return 228;
  }
  if (isTablet) {
    return 320;
  }
  return 421;
}

export function getUnitDetailsLayout(width: number): UnitDetailsLayout {
  const isPhone = width < UNIT_DETAILS_PHONE_MAX;
  const isTablet =
    width >= UNIT_DETAILS_PHONE_MAX && width < UNIT_DETAILS_TABLET_MAX;
  return {
    isPhone,
    isTablet,
    isCompact: isPhone || isTablet,
    carouselHeight: resolveCarouselHeight(isPhone, isTablet),
  };
}
